import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { validate, validatorFromFunction, validators, combine } from 'validate-redux-form';
import {
    renderField,
    AsyncSelectField,
    renderFieldRadio,
    renderSelectField,
    renderCurrency,
    renderTextArea,
    renderSelecttree
} from '../../../Utils/renderField';
import { TipoTransaccion } from '../../../../../utility/constants';
import { getSimbolo} from "../../../Utils/renderField/renderTableField";
import  {renderDropdownDateField} from "../../../Utils/renderField/otherrenders";
import {api} from 'api';

const getEmpresas = (search) => {
    let params = {}
    params.search = search
    params.es_principal = false
    return api.get("empresa", params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};

let PagoInternoForm = (props) => {
    const { handleSubmit, cuentas, texto_boton_movimiento, tipo_documento, mostrar_banco, mostrar_deposito,
        cerrarModal, tipo_cuenta, tipo_gastos, 
    } = props;
    return (
        <form name="PagoInternoForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
            <div>
                    <div style={{ border: "1px solid #e8e8e8", padding: "10px" }}>
                        <div className="d-flex justify-content-center">
                            <h4 className="t-primary text-uppercase align-self-center">pagar desde</h4>
                        </div>
                        <div className="row col-md-12 m-0 p-0 d-flex justify-content-center">
                                <div className={`form-group has-feedback  col-md-3 col-12 d-flex justify-content-center`}>
                                <Field
                                    name="tipo_cuenta"
                                    label="Cuenta"
                                    component={renderFieldRadio}
                                    type="radio"
                                    value={"true"}
                                    className="form-control" />
                            </div>
                            <div className={`form-group has-feedback col-md-3  col-12 d-flex justify-content-center`}>
                                <Field
                                    value={"false"}
                                    name="tipo_cuenta"
                                    label="Mi Caja Chica"
                                    component={renderFieldRadio}
                                    type="radio"
                                    className="form-control" />
                            </div>
                        </div>
                    </div>
                
            <br />
            <div className="row ">
                <div className="form-group has-feedback col-md-6">
                    <label className="t-azul" htmlFor="nombre">Empresa</label>
                    <Field
                        name="empresa"
                        label="nombre"
                        component={AsyncSelectField}
                        loadOptions={getEmpresas}
                        type="text"
                        valueKey="id"
                        labelKey="nombre"
                        onChange={(e) => {

                        }}
                        className="form-control" />
                </div>
                {
                    (tipo_cuenta) && (
                        <div className={`form-group has-feedback  col-md-6  col-12 `}>
                            <label className="t-azul" htmlFor="numero_cuenta">No. de Cuenta</label>
                            <Field
                                name="numero_cuenta"
                                label="label"
                                labelKey="label" valueKey="id"
                                component={renderSelectField}
                                options={cuentas}
                                className="form-control"
                            />
                        </div>
                    )
                }

            </div>
            {
                (tipo_cuenta) && (
                    <div className="row justify-content-center">
                        <div className="form-group has-feedback col-md-6">
                            <label className="t-azul" htmlFor="tipo_documento">Tipo de Movimiento</label>
                            <Field
                                name="tipo_documento"
                                label="tipo_documento"
                                labelKey="label" valueKey="value"
                                component={renderSelectField}
                                options={TipoTransaccion}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group has-feedback col-md-6">
                            <label className="t-azul" htmlFor="no_documento">{tipo_documento}</label>
                            <Field name="no_documento" label="no_documento" component={renderField} type="text" className="form-control" />
                        </div>
                    </div>
                )
            }
            {
                (mostrar_deposito) && (
                    <div className="row justify-content-center">
                        <div className="form-group has-feedback col-md-6">
                            {
                                (mostrar_banco) && (
                                    <Fragment>
                                        <label className="t-azul" htmlFor="no_boleta">No. Depósito</label>
                                        <Field name="no_boleta" label="no_boleta" component={renderField} type="text" className="form-control" />
                                    </Fragment>
                                )
                            }

                        </div>
                        <div className="form-group has-feedback col-md-6">
                            <label className="t-azul" htmlFor="no_documento">Banco</label>
                            <Field name="banco_depositado" label="banco_depositado" component={renderField} type="text" className="form-control" />
                        </div>
                    </div>
                )
            }
            <div className="row ">
            <div className="form-group has-feedback col-md-6">
                    <label className="t-azul" htmlFor="nombre">Monto</label>
                    <Field
                        name={`monto`}
                        label="tipo_cambio"
                        prefix={"Q"}
                        component={renderCurrency}
                        parse={cell => parseFloat(cell)}
                        className="form-control"
                        top={{ top: "67px", position: "inherit" }}
                    />
            </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="form-group has-feedback col-12 m-0 p-0">
                        <label className="t-azul" htmlFor="descripcion">Descripción</label>
                        <Field
                            name="descripcion"
                            label="descripcion"
                            rows={7}
                            component={renderTextArea}
                            type="text"
                            top={{ top: "174px" }}
                            className="form-control" />
                    </div>
                </div>
            </div>

            </div>

            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-sm-around " >
                        <button type="button" onClick={cerrarModal} className="btn btn-secondary  align-self-center">CANCELAR</button>
                        <button type="submit" className="btn btn-primary m-1 align-self-center">
                            {
                                (texto_boton_movimiento) ? (`${texto_boton_movimiento}`) : ("AGREGAR PAGO")
                            }
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};


PagoInternoForm =  reduxForm({
    form: 'PagoInternoForm', // a unique identifier for this form
    initialValues: {
        tipo_cuenta: 'true',
        fecha: new Date(),
        fecha_cobro: new Date(),
    },
    validate: (data) => {
        return validate(data, {
            fecha: validators.exists()('Este campo es requerido'),
            numero_cuenta: validators.exists()('Este campo es requerido'),
            tipo_documento: validators.exists()('Este campo es requerido'),
            no_documento: validators.exists()('Este campo es requerido'),
            monto: validators.exists()('Este campo es requerido'),
            empresa: validators.exists()('Este campo es requerido'),
            descripcion: validators.exists()('Este campo es requerido'),
        });
    },
})(PagoInternoForm);

const selector = formValueSelector('PagoInternoForm');
PagoInternoForm = connect(state => {
    const tipo_movimiento = selector(state, 'tipo_documento')
    const tipo_cuenta_form = selector(state, 'tipo_cuenta')

    let tipo_cuenta = true
    let esCheque = false;
    let es_tarjeta = false;
    if(tipo_cuenta_form == "false"){
        tipo_cuenta = false
    }
    let tipo_documento = 'Documento de Registro'
    if(tipo_movimiento){
        let seleccionado = _.find(TipoTransaccion, (tipo) => {
            return tipo.value == tipo_movimiento
        });
        tipo_documento = seleccionado.ayuda
        if (seleccionado.value == 2){esCheque = true}
        if(seleccionado.value == 5){es_tarjeta = true}
    }
    return{
        tipo_documento,
        tipo_cuenta,
        esCheque,
        es_tarjeta
    }


})(PagoInternoForm);


export default PagoInternoForm;
